export function isEventTargetNode(eventTarget) {
    return eventTarget instanceof Node;
}
//# sourceMappingURL=EventUtils.js.map